import FieldSet from '../../FieldSet';

import { PortalCommentsCount } from './PortalCommentsCount';
import { LastPortalCommentAt } from './LastPortalCommentAt';

export class PortalCommentsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [PortalCommentsCount, LastPortalCommentAt];
  }

  get title() {
    return 'Portal comments';
  }
}
